import React from 'react';
import PropTypes from 'prop-types';

import { normalizeValues } from '@hydra/utils/chart';

import Translate from '@hydra/common/components/i18n';
import WorldMap from '@hydra/common/components/WorldMap';
import ReviewSkeleton from '@hydra/common/components/ReviewSkeleton';

import Criterium from '@hydra/common/criterium/Criterium';
import CriteriumText from '@hydra/common/criterium/CriteriumText';

export const PjFbInsightLocations = ({ criterium }) => {
  if (!criterium) {
    return (
      <Criterium criterium={{ type: 'pj_fb_insight_locations', score: null, importance: 0, solvability: 0 }} clickable={false}>
        <ReviewSkeleton height={490} />
      </Criterium>
    );
  }
  const { data } = criterium;

  const countries = Object.keys(data);
  const values = Object.values(data);

  const normalizedValues = normalizeValues(values.map(value => value), 1);
  const normalizedData = countries.map((countryCode, index) => {
    return {
      country: countryCode || '',
      value: normalizedValues[index]
    };
  });

  const hasData = normalizedValues.some(value => value > 0);

  const content = hasData
    ? <WorldMap highlights={normalizedData} />
    : (
      <>
        <CriteriumText firstLine={<Translate content='pj_facebook_missing_metrics_data' />} />
        <WorldMap highlights={normalizedData} />
      </>
      );

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

PjFbInsightLocations.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.object
  })
};

export default React.memo(PjFbInsightLocations);
